import { render, staticRenderFns } from "./NotFoundSecured.vue?vue&type=template&id=7666201e&scoped=true"
import script from "./NotFoundSecured.vue?vue&type=script&lang=js"
export * from "./NotFoundSecured.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7666201e",
  null
  
)

export default component.exports